import axios from "axios";
import UserStore from "@/store/userStore";
import { EventBus } from "../mixins/event-bus";

export default {
  methods: {
    getState: function(state) {
      return this.$store.state[state];
    },
    setState: function(state, value) {
      this.$store.state[state] = value;
    },
    objectIsSame: function(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    },
    getApiEndpoint(name) {
      return this.$store.state.api + "/" + name;
    },
    userIsLogged() {
      return UserStore.state.logged;
    },
    autoHeight(event) {
      event.target.style.height = "100px";
      event.target.style.height = event.target.scrollHeight + "px";
    },
    waitForAuth() {
      return new Promise(resolve => {
        if (UserStore.state.init) {
          if (UserStore.state.logged) {
            resolve(true);
          } else {
            resolve(false);
          }
        }
        EventBus.$on("userInit", logged => {
          if (logged) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    bgUrl(imgObject) {
      return (
        "url(" + imgObject.base_path + imgObject.breakpoints.md["1x"] + ")"
      );
    },
    async apiAuth(username, password) {
      const url = this.$store.state.basUrl + "/wp-json/jwt-auth/v1/token";
      return axios
        .post(url, {
          username,
          password
        })
        .then(response => {
          return response.data;
        })
        .catch(error => {
          return error.response;
        });
    },
    async getApi(name) {
      const url = this.getApiEndpoint(name);
      const found_endpoint = this.$store.state.endpoints.find(endpoint => {
        return endpoint.name === name;
      });

      if (found_endpoint) {
        return found_endpoint.data;
      }
      return axios
        .get(url)
        .then(response => {
          this.$store.state.endpoints.push({
            name: name,
            data: response.data
          });
          return response.data;
        })
        .catch(error => {
          return error.response;
        });
    },
    containObject: function(array, obj) {
      for (var key in array) {
        if (JSON.stringify(array[key]) === JSON.stringify(obj)) {
          return true;
        }
      }
      return false;
    }
  },
  data: function() {
    return {};
  }
};
